<template>

	<div class="pb--4" @click.stop.prevent="handleClick">
		<div class="accordion bdr--light-gray accordion--arrows">
			<div class="accordion__item bdr__top--light-gray" data-accordion-type="default"
				v-for="(acc, index) in accordions" :key="acc.title">
				<button :class="{ 'accordion__header--active': acc.display }" :id="'acc' + index"
					@click="acc.display = !acc.display" class="accordion__header txt--md txt--strong">
					{{ acc.title }}
				</button>
				<div :id="'acc-content' + index" class="accordion__content wysiwyg"
					:aria-labelledby="'acc' + index"
					:class="{ 'accordion__content--active active': acc.display }" v-html="acc.content"></div>
			</div>
		</div>
	</div>

</template>

<script>
export default {
	name: "Content",
	methods: {
		handleClick(e) {
			if (e.target.matches("a")) {
				let url = e.target.href;
				let target = e.target.target == "_blank" ? "_blank" : "_self";
				let dataId = e.target.dataset.id == null ? -1 : e.target.dataset.id;
				var isnativeapp = document.getElementById("isnativeapp");
				if (isnativeapp === undefined || isnativeapp === null) {
					window.open(url, target);
				}
				else {
					if (target == "_blank") {
						let data = { title: '', nodeid: dataId, href: url, target: target };
						window.Native('dataCallback', data);
					}
				}
			}
		},
	},
	data: function () {
		return {
			accordions: [
				{
					display: false,
					title: "Guidance",
					content: `
						<p>
							<strong>BAPEN Malnutrition Action Group (MAG)</strong>, Elia, M. (2003). <a href="https://www.bapen.org.uk/resources-and-education/publications-and-reports/must" target="_blank">The ‘MUST’ report. Nutritional screening of adults: a multidisciplinary responsibility. 
							Development and use of the ‘Malnutrition Universal Screening’ Tool (‘MUST’) FOR ADULTS</a>.
						</p>
						<p>
							<strong>BAPEN Malnutrition Action Group (MAG)</strong> (2003).  
							<a href="https://www.bapen.org.uk/pdfs/must/must_explan.pdf" target="_blank">The ‘MUST’ explanatory booklet. A guide to the ‘Malnutrition Universal Screening Tool’ (‘MUST’) for adults.</a>
						</p>
						<p>
							Use of the MUST tool is advocated by:
						</p>
						<ul>
							<li>
								<strong>The Care Inspectorate</strong> <a href="https://www.careinspectorate.com/images/documents/1101/Best%20Practice%20Standards%20and%20Guidance%20%20Food%20,%20Fluid%20and%20Nutrition%20Care%20Homes%20for%20Older%20People%201.pdf">Best Practice Standards and Guidance on Food,
								Fluid and Nutrition for Care Homes for Older People (2014)</a>.
							</li>
							<li>
								<strong>Healthcare Improvement Scotland Food</strong>, <a href="https://www.healthcareimprovementscotland.org/our_work/standards_and_guidelines/stnds/nutritional_care_standards.aspx" target="_blank">Fluid and Nutritional Care Standards (2014)</a>.  
							</li>
						</ul>
					`
				}, {
					display: false,
					title: "Patient information & self-management resources",
					content: `
						<p>NHS Inform: <a href="https://www.nhsinform.scot/illnesses-and-conditions/nutritional/malnutrition" target="_blank">Malnutrition</a></p>
					`
				},
				{
					display: true,
					title: "Regulatory Information",
					content: `
						<p>
						<strong>Product Name: </strong>Calculator Suite <br>
						<strong>Calculator Name: </strong><span id="calculator-name">Malnutrition Universal Screening Tool (MUST)</span><br>
						<strong>Calculator Version: </strong> v2.1.0
						</p>  
						<div class="row">
						<div class="col-xs-4 col-lg-2">
							<img src="/img/cemark/shii.png" alt="InnoScot Health"/>
						</div>
						<div class="col-xs-8 col-lg-10">
							<p id="address">
                  Innoscot Health<br>
									Suite 23, The Pentagon Centre<br>
									36 Washington Street<br>
									Glasgow<br>
									G3 8AZ
                </p>
						</div>
						</div>
						<div class="row">
							<div class="col-xs-12">
								<p>
								<img src="/img/cemark/ukca.png" alt="UK Conformity Assessed"/>
								<!-- <img src="/img/cemark/ce.png" alt="CE marking"/> -->
								</p>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-4 col-lg-2">
								<img src="/img/cemark/warning.png" alt="InnoScot Health"/>
							</div>
							<div class="col-xs-8 col-lg-10">
								<p>
								<strong>Calculators are <u>not</u> intended to be used by members of the public as a substitute for professional advice.</strong>
								</p>
							</div>
						</div>
						
						<div class="row">
							<div class="col-xs-4 col-lg-2">
								<img src="/img/cemark/info.png" alt="More Information on Right Decision"/>
							</div>
							<div class="col-xs-8 col-lg-10">
								<p>
									<a id="instructions" href="https://rightdecision.scot.nhs.uk/quality-assurance-and-regulation/calculator-suite-instructions-for-use.pdf" target="_blank">Instructions for use</a>
								</p>
							</div>
						</div>
					`
				}
			]
		}
	}
};
</script>
